import { STRATEGY_BENCHMARK_CHART_STRATEGY_IDS } from "./strategyBenchmarkChartConfig";

export const STRATEGY_BENCHMARK_CHART_TIMEFRAME = Object.freeze({
  THREE_MONTHS: "3M",
  YTD: "YTD",
  ONE_YEAR: "1Y",
  FIVE_YEARS: "5Y",
  TEN_YEARS: "10Y",
  FIFTEEN_YEARS: "15Y",
  ALL: "ALL"
});

export const STRATEGY_BENCHMARK_CHART_TIMEFRAMES = Object.freeze(
  Object.values(STRATEGY_BENCHMARK_CHART_TIMEFRAME)
);

const HIDDEN_TIMEFRAMES_BY_STRATEGY = Object.freeze({
  [STRATEGY_BENCHMARK_CHART_STRATEGY_IDS.SUPPLY_DEMAND]: Object.freeze([
    STRATEGY_BENCHMARK_CHART_TIMEFRAME.TEN_YEARS,
    STRATEGY_BENCHMARK_CHART_TIMEFRAME.FIFTEEN_YEARS
  ])
});

export function getStrategyBenchmarkChartTimeframes(strategy) {
  const hiddenTimeframes = HIDDEN_TIMEFRAMES_BY_STRATEGY[strategy];

  if (!hiddenTimeframes) {
    return STRATEGY_BENCHMARK_CHART_TIMEFRAMES;
  }

  return STRATEGY_BENCHMARK_CHART_TIMEFRAMES.filter(
    timeframe => !hiddenTimeframes.includes(timeframe)
  );
}

export function isValidStrategyBenchmarkChartTimeframe(timeframe) {
  return STRATEGY_BENCHMARK_CHART_TIMEFRAMES.includes(timeframe);
}
